var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrophyFill(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#555;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M2.507.5a.5.5,0,0,1,.5-.5H13.037a.5.5,0,0,1,.5.5q0,.807-.034,1.536a3,3,0,1,1-1.136,5.89c-.792,1.865-1.883,2.777-2.841,3.011V13.11l1.429.356a1.5,1.5,0,0,1,.539.255L13.338,15.1a.5.5,0,0,1-.3.9H3.008a.5.5,0,0,1-.3-.9l1.843-1.379a1.5,1.5,0,0,1,.539-.255l1.429-.356V10.937C5.561,10.7,4.47,9.791,3.677,7.925a3,3,0,1,1-1.135-5.89Q2.507,1.268,2.507.5Zm.1,2.54a2,2,0,1,0,.722,3.935A17.954,17.954,0,0,1,2.606,3.04ZM12.718,6.975A2,2,0,1,0,13.44,3.04,18.062,18.062,0,0,1,12.718,6.975Z",
    transform: "translate(-0.021)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyFill);
export default __webpack_public_path__ + "static/media/trophy-fill.5a7c8a6ba31b699b26869388fc4fe5cb.svg";
export { ForwardRef as ReactComponent };